<template>
  <Layout>
    <CreateEditLojaModal
      v-if="showCreateEditLojaModal"
      :lojaId="lojaIdSelected"
      @closeModal="closeCreateEditLojaModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Lojas</h5>
        <div v-if="getModuleUserByCode('0.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Cadastrar Loja"
            @click="createEditLoja()"
          >
            Cadastrar Loja
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListLojas :lojas="lojas" @editLoja="createEditLoja" />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import CreateEditLojaModal from '@/components/administration/lojas/CreateEditLojaModal.vue'
import ListLojas from '../../../components/administration/lojas/ListLojas.vue'

export default {
  name: 'Lojas',

  components: {
    Layout,
    CreateEditLojaModal,
    LoadingData,
    ListLojas,
  },

  data() {
    return {
      title: 'Lojas',
      items: [
        {
          text: 'Administração',
        },
        {
          text: 'Lojas',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditLojaModal: false,
      lojas: null,
      lojaIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getLojas() {
      try {
        this.lojas = await this.$store.dispatch('getLojas')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditLoja(lojaId) {
      this.lojaIdSelected = lojaId || null
      this.showCreateEditLojaModal = true
    },

    closeCreateEditLojaModal(loadListLojas) {
      if (loadListLojas) {
        this.getLojas()
      }
      this.showCreateEditLojaModal = false
    },
  },

  mounted() {
    this.getLojas()
  },
}
</script>
